module.exports = __webpack_public_path__ + "static/img/huanyin.ae1f0c08.png";